import type { GameModeDefinition } from "../levels/types";

export const teamDeathmatchMode: GameModeDefinition = {
  id: "tdm",
  name: "Team Deathmatch",
  shortLabel: "TDM",
  description: "Two teams race to the frag limit.",
  teamBased: true,
  teams: ["alpha", "bravo"],
  fragLimit: 50,
  timeLimitSeconds: 720,
};